import React, { FunctionComponent, useEffect } from 'react';
import getSchoolsMatinees from 'modules/SchoolsMatinees/actionCreators';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';
import { ApiCallStatus } from 'store/statesHelper';
import SlicesRenderer from 'modules/_shared/components/SlicesRenderer';
import PageLoading from 'modules/_shared/ui-components/PageLoading';

const SchoolsMatinees: FunctionComponent = () => {
  const { data, status } = useSelector<
    RootState,
    RootState['schoolsMatineesPage']
  >((state) => state.schoolsMatineesPage);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSchoolsMatinees());
  }, [dispatch]);

  return (
    <>
      {status === ApiCallStatus.LOADING && <PageLoading />}
      {status === ApiCallStatus.SUCCESS && (
        <SlicesRenderer slices={data!.slices} />
      )}
    </>
  );
};

export default SchoolsMatinees;
